module.exports = __webpack_public_path__ + "static/media/opensans-bolditalic-webfont.bc72a681.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-bolditalic-webfont.woff2
// module id = 1025
// module chunks = 0